import React, { useEffect, useState } from "react";

const convertTo24HourFormat = (time) => {
  const [hours, minutesAndPeriod] = time?.split(":");
  const [minutes, period] = minutesAndPeriod?.split(" ");
  let hours24 = parseInt(hours, 10);
  if (period === "PM" && hours24 < 12) hours24 += 12;
  if (period === "AM" && hours24 === 12) hours24 = 0;
  return { hours: hours24, minutes: parseInt(minutes, 10) };
};

const PlayTimer = ({ startTime, startDate }) => {
  const { hours, minutes } = convertTo24HourFormat(startTime);

  const startDateTime = new Date(startDate);
  startDateTime.setHours(hours);
  startDateTime.setMinutes(minutes);
  startDateTime.setSeconds(0);
  startDateTime.setMilliseconds(0);

  const [elapsedTime, setElapsedTime] = useState(() => {
    const now = Date.now();
    return Math.floor((now - startDateTime.getTime()) / 1000);
  });

  useEffect(() => {
    const interval = setInterval(() => {
      const now = Date.now();
      const diffInSeconds = Math.floor((now - startDateTime.getTime()) / 1000);
      setElapsedTime(diffInSeconds);
    }, 1000);

    return () => clearInterval(interval);
  }, [startDateTime.getTime()]);

  const formatDuration = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    return `${String(hours).padStart(2, "0")}hr:${String(minutes).padStart(2, "0")}min`;
  };

  return (
    <div className="font-semibold">
      {elapsedTime < 0 ? "Starting Soon .." : formatDuration(elapsedTime)}
    </div>
  );
};

export default PlayTimer;
